import React, { useState } from 'react';
import VegaIcon from './vegaIcons';
import { FAQS } from './vegaData';

export default function VegaFAQ() {
  const [open, setOpen] = useState(0);

  return (
    <section
      id="faq"
      className="vd-section-y px-6 lg:px-10"
      style={{ borderTop: '1px solid var(--line-soft)' }}
    >
      <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
        <div style={{ maxWidth: '42rem', marginBottom: '2.5rem' }}>
          <div className="vd-eyebrow" style={{ marginBottom: '1.25rem' }}>Questions</div>
          <h2
            className="vd-font-display vd-ink"
            style={{ fontSize: 'clamp(1.75rem, 3.5vw, 2.5rem)', lineHeight: 1.2 }}
          >
            Frequently asked, <span style={{ fontStyle: 'italic' }}>honestly answered.</span>
          </h2>
        </div>

        <div style={{ borderTop: '1px solid var(--line)', borderBottom: '1px solid var(--line)' }}>
          {FAQS.map((f, i) => (
            <div key={i} style={{ borderBottom: i < FAQS.length - 1 ? '1px solid var(--line)' : 'none' }}>
              <button
                onClick={() => setOpen(open === i ? -1 : i)}
                style={{
                  width: '100%',
                  padding: '1.25rem 0',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  textAlign: 'left',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                }}
              >
                <span
                  className="vd-font-display vd-ink"
                  style={{ fontSize: '1.25rem', paddingRight: '1rem' }}
                >
                  {f.q}
                </span>
                <span
                  className="vd-accordion-icon vd-ink-faint"
                  style={{
                    flexShrink: 0,
                    transform: open === i ? 'rotate(45deg)' : 'rotate(0deg)',
                    transition: 'transform 0.25s ease',
                  }}
                >
                  <VegaIcon name="plus" className="w-5 h-5" />
                </span>
              </button>

              <div
                style={{
                  overflow: 'hidden',
                  maxHeight: open === i ? '240px' : '0',
                  opacity: open === i ? 1 : 0,
                  transition: 'max-height 0.3s ease, opacity 0.3s ease',
                }}
              >
                <p className="vd-ink-soft" style={{ paddingBottom: '1.5rem', maxWidth: '42rem', lineHeight: 1.7 }}>
                  {f.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
